'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _themeA11y = require('@shopify/theme-a11y');

var _makemodelyears = require('../core/makemodelyears');

var _makemodelyears2 = _interopRequireDefault(_makemodelyears);

var _productBybAddedCart = require('./product-byb-added-cart');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

window.byb = {
    make: null,
    model: null,
    year: null,
    product: null,
    companion_products: [],
    total: null
};

document.addEventListener('DOMContentLoaded', function () {
    var bumper = document.querySelector('[data-bumper-product]');
    if (!bumper) return;

    window.byb.product = {
        id: bumper.getAttribute('data-select-bumper'),
        price: bumper.getAttribute('data-price'),
        title: bumper.getAttribute('data-title'),
        series: bumper.getAttribute('data-series'),
        method: bumper.getAttribute('data-method'),
        type: bumper.getAttribute('data-type'),
        tags: bumper.getAttribute('data-tags')
    };

    updateTotal();
    bindAddToCart();
    bindSaveBumper();
});

var generateCustomizerLink = function generateCustomizerLink() {
    if (!window.byb || !window.byb.product || !window.byb.make || !window.byb.model || !window.byb.year || !window.byb.companion_products) return;

    var _window$byb = window.byb,
        make = _window$byb.make,
        model = _window$byb.model,
        year = _window$byb.year,
        _window$byb$product = _window$byb.product,
        method = _window$byb$product.method,
        type = _window$byb$product.type,
        id = _window$byb$product.id;

    var companionCsv = window.byb.companion_products.map(function (cp) {
        return cp.variant;
    }).join(',');

    var url = 'https://www.movebumpers.com/pages/build-diy-bumper-kits?make=' + make + '&model=' + model + '&year=' + year + '&method=product-method--' + method + '&type=product-type--' + type + '&cp=' + companionCsv + '&bumper=' + id;

    window.byb.customizer_url = url;

    return true;
};

var bindSaveBumperModal = function bindSaveBumperModal() {
    document.querySelector('[data-draft-order]').addEventListener('click', function (event) {

        if (document.getElementById('email').value == '' && window.byb.product == null) {
            return;
        }

        event.target.setAttribute('disabled', 'disabled');
        var companionList = [];
        var _companionList = [];
        var lineItems = [];
        window.byb.companion_products.forEach(function (cp) {
            companionList.push(cp.variant);
            _companionList.push('<strong>' + cp.title + '</strong> - ' + cp.variant_title + ' - ' + Shopify.formatMoney(cp.price));

            lineItems.push({
                variant_id: cp.variant,
                quantity: 1,
                properties: {
                    _product_title: '' + cp.title,
                    for: window.byb.product.title
                }
            });
        });

        lineItems.push({
            variant_id: window.byb.product.id,
            quantity: 1,
            properties: {
                make: window.byb.make,
                model: window.byb.model,
                year: window.byb.year,
                _total_price: window.byb.total,
                _product_title: window.byb.product.title,
                _center_code: getCenter(),
                _companions_display: _companionList.join('<br/>'),
                _tags: window.byb.product.tags,
                _companions: companionList.join(',')
            }
        });

        var formData = {
            email: document.getElementById('email').value,
            preview_url: window.byb.customizer_url,
            line_items: lineItems
        };

        $.post('https://fabricators.movebumpers.com/api/save-bumper', formData).done(function (msg) {
            document.querySelector('[data-save-bumper-content').classList.add('hidden');
            document.querySelector('[data-save-bumper-success').classList.remove('hidden');
            document.querySelector('[data-save-bumper-url]').setAttribute('href', window.byb.customizer_url);
            document.querySelector('[data-save-bumper-url]').innerHTML = window.byb.customizer_url;
        }).fail(function (xhr, status, error) {
            event.target.removeAttribute('disabled');
            console.log(error);
        });
    });
};

// Get center code
var getCenter = function getCenter() {
    var centers = _makemodelyears2.default.getCenterByMMY(window.byb.make, window.byb.model, window.byb.year);
    var series = window.byb.product.series;;
    var center = centers.filter(function (center) {
        return center.series.toLowerCase() == series;
    });
    var type = window.byb.product.type;
    center = center.filter(function (center) {
        return center.center_type.toLowerCase() == type;
    });

    if (center.length > 0) {
        return center[0].center_code;
    }

    return 'empty';
};

var bindSaveBumper = function bindSaveBumper() {
    document.querySelector('[data-save-bumper]').addEventListener('click', function () {
        if (!generateCustomizerLink()) return;
        closeModal();

        var popupBtn = document.querySelector('[data-save-my-bumper-toggle]');
        if (popupBtn) popupBtn.click();
    });
};

var bindAddToCart = function bindAddToCart() {
    document.querySelector('[data-add-all]').addEventListener('click', function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(event) {
            var companionList, _companionList, itemsToAdd, items, isSuccessful;

            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            event.target.setAttribute('disabled', 'disabled');
                            companionList = [];
                            _companionList = [];
                            itemsToAdd = [];


                            window.byb.companion_products.forEach(function (cp) {
                                companionList.push(cp.variant);
                                _companionList.push('<strong>' + cp.title + '</strong> - ' + cp.variant_title + ' - ' + Shopify.formatMoney(cp.price));
                                itemsToAdd.push({
                                    id: cp.variant,
                                    quantity: 1,
                                    properties: {
                                        _product_title: '' + cp.title,
                                        for: window.byb.product.title
                                    }
                                });
                            });

                            itemsToAdd.push({
                                id: window.byb.product.id,
                                quantity: 1,
                                properties: {
                                    make: window.byb.make,
                                    model: window.byb.model,
                                    year: window.byb.year,
                                    _total_price: window.byb.total,
                                    _product_title: window.byb.product.title,
                                    _center_code: getCenter(),
                                    _companions_display: _companionList.join('<br/>'),
                                    _tags: window.byb.product.tags,
                                    _companions: companionList.join(',')
                                }
                            });

                            items = { "items": itemsToAdd };
                            _context.next = 9;
                            return post(items);

                        case 9:
                            isSuccessful = _context.sent;


                            closeModal();

                            if (isSuccessful) (0, _productBybAddedCart.toggleAddedModal)(true);
                            event.target.removeAttribute('disabled');

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function (_x) {
            return _ref.apply(this, arguments);
        };
    }());
};

var post = function post(data) {
    return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }).then(function (response) {
        return true;
    }).catch(function (error) {
        return false;
    });
};

function resetCompanionProducts() {
    var companionProductsEl = document.querySelector('[data-companion-products]');
    if (!companionProductsEl) return;

    var companionProductsString = companionProductsEl.getAttribute('data-companion-products');

    window.byb.companion_products = [];

    document.querySelectorAll('[data-companion-option]').forEach(function (companion) {
        var handle = companion.getAttribute('data-companion-option');
        var dropdown = companion.querySelector('[data-dropdown]');

        if (!dropdown || !companionProductsString.includes(handle)) return;

        var variantArray = JSON.parse(companionProductsString)[handle].split(',');

        variantArray.forEach(function (variant, index) {
            if (index == 0) dropdown.setSelectedOption(variant);

            var selectOption = dropdown.querySelector('select option[value="' + variant + '"]');
            var dropdownOption = dropdown.querySelector('[data-dropdown-option="' + variant + '"]');

            if (!selectOption) return;

            selectOption.disabled = false;
            if (dropdownOption) dropdownOption.disabled = false;
        });
    });

    updateExcludedOptions();
}

function companionProductExcludedMMY() {
    var mmy = window.byb.make + '--' + window.byb.model + '--' + window.byb.year;

    document.querySelectorAll('[data-companion-option]').forEach(function (companion) {
        var selectOptions = companion.querySelectorAll('select option');

        selectOptions.forEach(function (selectOption) {
            var variantId = selectOption.value;
            var dropdownOption = companion.querySelector('[data-dropdown-option="' + variantId + '"]');
            var excludedMmyString = selectOption.getAttribute('data-excluded-mmy');

            if (!excludedMmyString || excludedMmyString == 'empty' || !excludedMmyString.includes(mmy)) return;

            selectOption.disabled = true;
            if (dropdownOption) dropdownOption.disabled = true;
        });
    });
}

// disable options if another exlcuded option is selected
var companionProductExcludedVariants = function companionProductExcludedVariants() {
    var companionsSelects = document.querySelectorAll('[data-companion-option] select');
    var companions = document.querySelectorAll('[data-companion-option]');

    var selectedVariants = [];

    companionsSelects.forEach(function (select) {
        if (select.value) selectedVariants.push(select.value);
    });

    companions.forEach(function (companion) {
        var selectOptions = companion.querySelectorAll('select option');

        selectOptions.forEach(function (selectOption) {
            var dropdownOption = companion.querySelector('[data-dropdown-option="' + selectOption.value + '"]');
            var excludedVariants = JSON.parse(selectOption.getAttribute('data-excluded-variants'));

            if (!excludedVariants) return;

            Object.keys(excludedVariants).forEach(function (key) {
                var variantCsv = excludedVariants[key];

                if (!variantCsv || typeof variantCsv !== 'string') return;

                variantCsv.split(',').forEach(function (variant) {
                    if (!selectedVariants.includes(variant)) return;

                    selectOption.disabled = true;
                    if (dropdownOption) dropdownOption.disabled = true;
                });
            });
        });
    });
};

var updateExcludedOptions = function updateExcludedOptions() {
    document.querySelectorAll('[data-companion-option]').forEach(function (companion) {
        var selectOptions = companion.querySelectorAll('select option');

        selectOptions.forEach(function (selectOption) {
            var dropdownOption = companion.querySelector('[data-dropdown-option="' + selectOption.value + '"]');

            selectOption.disabled = false;
            if (dropdownOption) dropdownOption.disabled = false;
        });
    });

    companionProductExcludedMMY();
    companionProductExcludedVariants();
};

var showHideDefaultBumpers = function showHideDefaultBumpers() {
    var defaultBumpers = document.querySelectorAll('[data-byb-images] .default-bumper');
    var shouldHide = false;

    document.querySelectorAll('[data-companion-option] select').forEach(function (select) {
        var selectedOption = select.options[select.selectedIndex];
        if (!selectedOption) return;

        var hideDefaultBumper = selectedOption.getAttribute('data-hide-bumper') === '1';

        if (hideDefaultBumper) shouldHide = true;
    });

    defaultBumpers.forEach(function (defaultBumper) {
        return defaultBumper.classList.toggle('hide', shouldHide);
    });
};

var resetGallerySlider = function resetGallerySlider() {
    if (!window.productGallerySlider) return;

    window.productGallerySlider.selectCell(0);
};

var updateRecommendedProducts = function updateRecommendedProducts() {
    var recommendedProductArray = [];

    window.byb.companion_products.forEach(function (_ref2) {
        var variant = _ref2.variant;

        var matchedOption = document.querySelector('[data-companion-option] option[value="' + variant + '"');
        if (!matchedOption) return;

        var recommendedProduct = matchedOption.getAttribute('data-recommended-product');

        if (recommendedProduct && !recommendedProductArray.includes(recommendedProduct)) {
            recommendedProductArray.push(recommendedProduct);
        }
    });

    (0, _productBybAddedCart.updateDisplayedProducts)(recommendedProductArray);
};

// Companion Product Change Event
function bindCompanionSelects() {
    // listen for mmy changes
    document.addEventListener('MMY_CHANGED', resetCompanionProducts, false);

    document.querySelectorAll('[data-companion-option] select').forEach(function (select) {
        select.addEventListener('change', function (event) {
            var imageWrappers = document.querySelectorAll('[data-byb-images]');

            var option = event.target.options[event.target.selectedIndex];
            var customizerImage = option.getAttribute('data-customizer-image');
            var handle = option.getAttribute('data-companion-variant');

            // remove existing images related to this handle
            var currentImages = document.querySelectorAll('[data-byb-images] img[data-handle="' + handle + '"');
            currentImages.forEach(function (image) {
                return image.remove();
            });

            // add new images if they exist
            if (customizerImage) {
                imageWrappers.forEach(function (wrapper) {
                    var image = document.createElement('img');
                    image.src = customizerImage;
                    image.setAttribute('data-handle', handle);
                    image.style.zIndex = option.getAttribute('data-z-index');
                    wrapper.append(image);
                });
            }

            var selected = {
                "type": option.getAttribute('data-companion-variant'),
                "variant": event.target.value,
                "title": option.getAttribute('data-product-title'),
                "variant_title": option.getAttribute('data-variant-title'),
                "price": option.getAttribute('data-price')
            };

            // remove existing option
            window.byb.companion_products = window.byb.companion_products.filter(function (item) {
                return item.type !== selected.type;
            });

            // add updated option
            window.byb.companion_products.push(selected);

            showHideDefaultBumpers();
            resetGallerySlider();
            updateExcludedOptions();
            updateTotal();
            updateRecommendedProducts();
        });
    });
}

var updateScrollLock = function updateScrollLock() {
    var stepModal = document.querySelector('[data-byb-step]');
    var siteHtml = document.querySelector('[data-site-html]');
    var siteBody = document.querySelector('[data-site-body]');

    if (!stepModal || !siteHtml || !siteBody) return;

    var currentStep = parseInt(stepModal.getAttribute('data-byb-step'), 10);
    var isActive = siteHtml.classList.contains('modal-active');

    if (currentStep > 0 && !isActive) {
        (0, _themeA11y.trapFocus)(stepModal);

        siteHtml.classList.add('modal-active');
        siteBody.classList.add('modal-active');
    } else if (currentStep <= 0 && isActive) {
        (0, _themeA11y.removeTrapFocus)();

        siteHtml.classList.remove('modal-active');
        siteBody.classList.remove('modal-active');
    }
};

var updateModalStep = function updateModalStep(isForward) {
    var stepModal = document.querySelector('[data-byb-step]');
    var stepContent = document.querySelector('[data-byb-step-content]');
    if (!stepModal) return;

    var currentStep = parseInt(stepModal.getAttribute('data-byb-step'), 10);
    var delta = isForward ? 1 : -1;
    var targetStep = currentStep + delta;

    if (targetStep < 0) targetStep = 0;

    stepModal.classList.toggle('active', targetStep > 0);
    stepModal.setAttribute('data-byb-step', targetStep);

    if (stepContent) stepContent.scrollTo(0, 0);

    updateScrollLock();
};

var closeModal = function closeModal() {
    var stepModal = document.querySelector('[data-byb-step]');
    if (!stepModal) return;

    stepModal.setAttribute('data-byb-step', 0);

    updateScrollLock();
};

// Companion Product Change Event
function initBybModal() {
    var changeStepBtns = document.querySelectorAll('[data-step-change]');
    var closeBtn = document.querySelector('[data-step-close]');

    changeStepBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
            var isForward = !!btn.hasAttribute('data-step-next');
            updateModalStep(isForward);
        });
    });

    closeBtn && closeBtn.addEventListener('click', closeModal);
}

// Total
function updateTotal() {
    var bumperTotal = parseFloat(window.byb.product.price);
    var companionTotal = 0;

    window.byb.companion_products.forEach(function (cp) {
        companionTotal += parseFloat(cp.price);
    });

    window.byb.total = bumperTotal + companionTotal;
    window.byb.formatedTotal = Shopify.formatMoney(window.byb.total);

    document.querySelectorAll('[data-formatted-total]').forEach(function (totalEl) {
        if (window.byb.formatedTotal != totalEl.innerText.replace(' ', '')) {
            var parentFormMeta = totalEl.closest('[data-form-meta]');

            if (parentFormMeta) {
                parentFormMeta.querySelectorAll('[data-price-prefix]').forEach(function (prefixEl) {
                    prefixEl.classList.add('hide');
                });
            }
        }

        totalEl.innerText = window.byb.formatedTotal;
    });
}

document.addEventListener('DOMContentLoaded', function () {
    bindCompanionSelects();
    bindSaveBumperModal();
    initBybModal();
});

document.addEventListener('shopify:section:load', function () {
    bindCompanionSelects();
    bindSaveBumperModal();
    initBybModal();
});